import { Link } from "@inertiajs/react"
import { Box, Flex, Separator } from "@radix-ui/themes"
import {
  Bot,
  Book,
  Calendar,
  FileUp,
  LayoutGrid,
  List,
  Mail,
  Megaphone,
  Newspaper,
  PieChart,
  Plus,
  Settings,
  Users,
} from "lucide-react"

import { NavMain } from "@/components/nav-main"
import { NavUser } from "@/components/nav-user"

import {
  newProjectEventPath,
  projectCampaignsPath,
  projectCustomersPath,
  projectDashboardPath,
  projectDocPath,
  projectEmailsPath,
  projectEventsPath,
  projectImportsPath,
  projectListsPath,
  projectNewslettersPath,
  projectSegmentsPath,
  projectSettingsPath,
} from "@/routes"
import type { NavItem } from "@/types"

import AppLogo from "./app-logo"

export function AppSidebar({ projectId }: { projectId: string }) {
  const mainNavItems: NavItem[] = [
    {
      title: "Dashboard",
      href: projectDashboardPath(projectId),
      icon: LayoutGrid,
    },
    {
      title: "Customers",
      href: projectCustomersPath(projectId),
      icon: Users,
    },
    {
      title: "Imports",
      href: projectImportsPath(projectId),
      icon: FileUp,
    },
    {
      title: "All Events",
      href: projectEventsPath(projectId),
      icon: Calendar,
    },
    {
      title: "Segments",
      href: projectSegmentsPath(projectId),
      icon: PieChart,
    },
    {
      title: "Custom Lists",
      href: projectListsPath(projectId),
      icon: List,
    },
    {
      title: "Campaigns",
      href: projectCampaignsPath(projectId),
      icon: Megaphone,
    },
    {
      title: "Email Templates",
      href: projectEmailsPath(projectId),
      icon: Mail,
    },
    {
      title: "Newsletters",
      href: projectNewslettersPath(projectId),
      icon: Newspaper,
    },
    {
      title: "API Endpoints",
      href: projectDocPath(projectId, "api"),
      icon: Book,
    },
    {
      title: "MCP",
      href: projectDocPath(projectId, "mcp"),
      icon: Bot,
    },
    {
      title: "Create testing event",
      href: newProjectEventPath(projectId),
      icon: Plus,
    },
    {
      title: "Settings",
      href: projectSettingsPath(projectId),
      icon: Settings,
    },
  ]

  return (
    <Flex direction="column" className="bg-gray-1 h-screen w-64 border-r">
      <Box p="4">
        <Link href={projectDashboardPath(projectId)} prefetch>
          <AppLogo />
        </Link>
      </Box>

      <Separator size="4" />

      <Box p="4" flexGrow="1">
        <NavMain items={mainNavItems} />
      </Box>

      <Box p="4">
        <NavUser />
      </Box>
    </Flex>
  )
}
